export const getQueryParam = (param: string) => {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const value = params.get(param);
  return value;
};
